const Separator = ({
    size = 0,
}) => {
    return (
        <div style={{ padding: size }}  />
    )
}

export default Separator;